import { render, staticRenderFns } from "./InternalTransferCreateEditModal.vue?vue&type=template&id=0007b923&"
import script from "./InternalTransferCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./InternalTransferCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports